import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/sino-invoiceInfo/invoiceInfo/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}
export const cmsInvoiceWinLotDetail = (current, size, params) => {
  return request({
    url: '/api/sino-winLot/winLot/cmsInvoiceWinLotDetail',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/sino-invoiceInfo/invoiceInfo/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/sino-invoiceInfo/invoiceInfo/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/sino-invoiceInfo/invoiceInfo/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/sino-invoiceInfo/invoiceInfo/submit',
    method: 'post',
    data: row
  })
}

export const cmsSave = (row) => {
  return request({
    url: '/api/sino-invoiceInfo/invoiceInfo/cmsSave',
    method: 'post',
    data: row
  })
}

export const validateOverduePlatform = (bidderId) => {
  return request({
    url: '/api/sino-winLot/winLot/validateOverduePlatform',
    method: 'get',
    params: {
      bidderId
    }
  })
}

